<template>
	<div class="quote-item-form">
        <v-stepper v-model="stepper">
            <v-stepper-header non-linear>
              <v-stepper-step :complete="stepper > 1" :rules="[validate_step_1]" editable edit-icon="fas fa-check" step="1">Product</v-stepper-step>
              <v-divider></v-divider>
              <v-stepper-step :complete="stepper > 2" :rules="[validate_step_2]" editable edit-icon="fas fa-check" step="2">Specs</v-stepper-step>
              <v-divider></v-divider>
              <v-stepper-step :complete="stepper > 3" editable edit-icon="fas fa-check" step="3">Options</v-stepper-step>
              <v-divider></v-divider>
              <v-stepper-step :complete="stepper > 4" editable edit-icon="fas fa-check" step="4">Advanced</v-stepper-step>
              <v-divider></v-divider>
              <v-stepper-step :complete="stepper > 5" editable edit-icon="fas fa-check" step="5">Build Options</v-stepper-step>
            </v-stepper-header>

            <v-stepper-items>
              <v-stepper-content step="1">
                <v-card class="mb-5">
                    <v-layout row wrap align-start>
                        <input type="hidden" name="product_id" v-model="product.product_id">
                        <input type="hidden" name="control_voltage" v-model="product.control_voltage">
                        <input v-if="!showWidth" type="hidden" name="diameter" v-model="product.diameter">
                        <v-flex xs12 md4 sm6 class="pa-2">
                            <v-select v-model="product.product_id" :error="hasError('product_id')" :error-messages="errorMsgs('product_id')" validate-on-blur :rules="[rules.required]" messages="Use drop down arrow to select options" label="Product" box required :items="availableProducts" item-text="label" item-value="id"></v-select>
                        </v-flex>
                        <v-flex xs12 md4 sm6 class="pa-2">
                            <v-text-field name="quantity" :error="hasError('quantity')" :error-messages="errorMsgs('quantity')" validate-on-blur :rules="[rules.required,rules.integer]" v-model="product.quantity" type="number" min="0" @wheel="$event.target.blur()" label="Quantity of this size" required box messages="Additional sizes can be added once this item  has been completed"></v-text-field>
                        </v-flex>
                        <v-flex xs12 md4 sm6 class="pa-2">
                            <v-text-field name="tagging" :error="hasError('tagging')" :error-messages="errorMsgs('tagging')" validate-on-blur v-model="product.tagging" box label="Custom Tagging" hint="i.e. EDH-1"></v-text-field>
                        </v-flex>
                    </v-layout>
                    <v-layout row wrap align-start pa-2 v-if="product.product_id">
                        <v-flex xs12 md4 sm6 class="pa-2">
                            <h3 class="mb-2">Duct Dimensions – External</h3>
                            <v-text-field v-model="product.height" :error="hasError('height')" :error-messages="errorMsgs('height')" validate-on-blur :rules="[rules.required,rules.number]" name="height" type="number" min="0" @wheel="$event.target.blur()" label="Height (.in)" box required v-if="showHeight"></v-text-field>
                            <v-text-field v-model="product.width" :error="hasError('width')" :error-messages="errorMsgs('width')" validate-on-blur :rules="[rules.required,rules.number]" name="width"  type="number" min="0" @wheel="$event.target.blur()" label="Width (.in)" box required v-if="showWidth"></v-text-field>
                            <v-select v-model="product.diameter" :error="hasError('diameter')" :error-messages="errorMsgs('diameter')" validate-on-blur :rules="[rules.required]" label="Diameter (.in)" box required :items="round_duct_options" v-if="showDiameter"></v-select>
                            <v-checkbox v-model="show_recess" label="Do you have internal insulation or double-wall duct?" :off-icon="'far fa-square'">
                                <v-tooltip top slot="append">
                                    <v-icon slot="activator" @click="showTip('ddddd')" small>fa-question-circle</v-icon>
                                    <span>A recess, or blank space, on the backside of the heater control panel equal to the thickness of internal insulation ensures thermal limits are in the airstream.</span>
                                </v-tooltip>
                            </v-checkbox>
                            <v-text-field v-if="show_recess" v-model="product.recess" :error="hasError('recess')" :error-messages="errorMsgs('recess')" validate-on-blur :rules="[rules.number,validate_recess]" name="recess" type="number" min="0" @wheel="$event.target.blur()" label="Recess (.in)" box></v-text-field>

                            <!-- <v-btn :color="product.duct_type == 'Rectangular' ? 'red' : ''" block @click="product.duct_type = 'Rectangular'">Rectangular<v-icon v-if="product.duct_type == 'Rectangular'" right>fa-check</v-icon></v-btn>
                            <v-btn :color="product.duct_type == 'Round' ? 'red' : ''" block @click="product.duct_type = 'Round'">Round<v-icon v-if="product.duct_type == 'Round'" right>fa-check</v-icon></v-btn>//-->
                            <div v-if="showType">
                                <v-radio-group label="Mount Type:" :error="hasError('mount_type')" :error-messages="errorMsgs('mount_type')" validate-on-blur :rules="[rules.required]" required v-model="product.mount_type" name="mount_type" row>
                                    <v-radio :off-icon="'far fa-circle'" label="Slip-in" value="S"></v-radio>
                                    <v-radio :off-icon="'far fa-circle'" label="Flange" value="F"></v-radio>
                                </v-radio-group>
                            </div>
                        </v-flex>
                        <v-flex xs12 md8 sm6 class="pa-2">
                            <div v-if="product.product == 'EDH2'">
                                <strong>E-Series - Flip-Able Duct Heater - Specifically designed, developed and tested with symmetry in mind eliminating the need for right and left handed designs or up and down flow designs.</strong>
                            </div>
                            <div v-if="product.product == 'ROUNDF'">
                                <strong>R-Series - Round Duct Heater - Designed for round duct applications.</strong>
                            </div>
                            <div v-if="product.product == 'EVH'">
                                <strong>E-Series - VAV Flip-Able Heater - Designed for VAV single duct applications, can be installed a minimum distance of 20” from the air damper valve.</strong>
                            </div>
                            <div v-if="product.product == 'EDH2' || product.product == 'A-EDH' || product.product == 'A-DHSPEC'">
                                <img v-if="product.mount_type == 'S'" src="/_assets/images/DuctHeaterType-Drawings-Rectangular.svg" class="duct-image">
                                <img v-if="product.mount_type == 'F'" src="/_assets/images/DuctHeaterType-Drawings-Rectangular-Flange.svg" class="duct-image">
                            </div>
                            <div v-if="product.product == 'EVH' || product.product == 'A-EVH'">
                                <img v-if="product.mount_type == 'S'" src="/_assets/images/DuctHeaterType-Drawings-Rectangular-VAV.svg" class="duct-image">
                                <img v-if="product.mount_type == 'F'" src="/_assets/images/DuctHeaterType-Drawings-Rectangular-VAV-Flange.svg" class="duct-image">
                            </div>
                            <div v-if="product.product == 'ROUNDF'">
                                <img src="/_assets/images/DuctHeaterType-Drawings-Round.svg" class="duct-image">
                            </div>
                        </v-flex>
                    </v-layout>
                </v-card>
                <div class="text-xs-right">
                    <v-btn @click="cancel()">Cancel</v-btn>
                    <v-btn :disabled="(hasError() || incomplete)" color="primary" @click="nextStep()">Continue</v-btn>
                </div>
              </v-stepper-content>

              <v-stepper-content step="2">
                <v-card class="mb-5">
                    <v-layout row wrap align-start>
                        <v-flex xs12 class="pa-2">
                            <h3 class="mb-2">General Specifications</h3>
                        </v-flex>
                        <v-flex xs12 sm6 class="pa-2">
                            <input type="hidden" name="voltage_id" :value="product.voltage.id" />
                            <v-select v-model="product.voltage" :error="hasError('voltage_id')" :error-messages="errorMsgs('voltage_id')" validate-on-blur :rules="[rules.required_voltage]" :messages="voltage_message" label="Voltage / Phase" box required :items="voltages" item-text="label" return-object></v-select>
                        </v-flex>
                        <v-flex xs12 sm6 class="pa-2">
                            <v-text-field v-model="product.kw" :error="hasError('kw')" :error-messages="errorMsgs('kw')" validate-on-blur :rules="[rules.required,rules.number]" name="kw" type="number" min="0" @wheel="$event.target.blur()" label="Kilowatts (kw)" box required></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm6 class="pa-2">
                            <v-text-field v-model="product.stages" :error="hasError('product.stages')" :error-messages="errorMsgs('product.stages')" validate-on-blur :rules="[rules.required,rules.integer,validate_stages]" hint="Number of stages must be set to 1 when selecting SCR control." name="stages" type="number" min="0" @wheel="$event.target.blur()" label="Number of Stages" box required></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm6 class="pa-2">
                            <v-select v-model="product.control_voltage" :error="hasError('product.control_voltage')" :error-messages="errorMsgs('product.control_voltage')" validate-on-blur :rules="[rules.required]" label="Control Voltage" box required :items="control_voltage_items"></v-select>
                        </v-flex>

                    </v-layout>
                </v-card>
                <div class="text-xs-right">
                    <v-btn @click="cancel()">Cancel</v-btn>
                    <v-btn @click="stepper = 1"><v-icon left>fas fa-arrow-alt-circle-left</v-icon>Back</v-btn>
                    <v-btn :disabled="(hasError() || incomplete)" color="primary" @click="nextStep()">Continue</v-btn>
                </div>
              </v-stepper-content>

              <v-stepper-content step="3" v-if="categories.length > 0">
                <v-card class="mb-5" height="400px">
                    <v-layout row wrap align-start class="pa-2">
                        <v-flex xs12>
                            <h3 class="mb-2">{{ categories[0].label }}</h3>
                        </v-flex>
                        <div class="accessory_columns">
                            <template v-for="(acc, k) in category_accessories(categories[0].id)">
                                <div :class="{ 'fade-more' : !show_accessory(acc) }" :key="'acc_' + k">
                                    <v-checkbox :error="hasError(acc.id)" :error-messages="errorMsgs(acc.id)" :disabled="!show_accessory(acc)" :hide-details="!hasError(acc.id)" slot="activator" v-on:click.passive="checkExclusiveOf(acc)" v-model="product.quote_accessories[acc.id]" :label="acc.label" name="accessories[]" :off-icon="'far fa-square'" :value="1">
                                        <v-tooltip v-if="acc.tooltip" top slot="append">
                                            <v-icon slot="activator" @click="showTip(acc.tooltip)" small>fa-question-circle</v-icon>
                                            <span>{{ acc.tooltip }} - ({{ acc.code }})</span>
                                        </v-tooltip>
                                    </v-checkbox>
                                </div>
                            </template>
                        </div>
                    </v-layout>
                </v-card>
                <div class="text-xs-right">
                    <v-btn @click="cancel()">Cancel</v-btn>
                    <v-btn @click="stepper = 2"><v-icon left>fas fa-arrow-alt-circle-left</v-icon>Back</v-btn>
                    <v-btn :disabled="(hasError() || incomplete)" color="primary" @click="nextStep()">Continue</v-btn>
                </div>
              </v-stepper-content>

              <v-stepper-content step="4" v-if="categories.length > 0">
                <v-card class="mb-5" height="400px">
                    <v-layout row wrap align-start class="pa-2">
                        <v-flex xs12>
                            <h3 class="mb-2">{{ categories[1].label }}</h3>
                        </v-flex>
                        <div class="accessory_columns">
                            <template v-for="(acc, k) in category_accessories(categories[1].id)">
                                <div :class="{ 'fade-more' : !show_accessory(acc) }" :key="'acc_' + k">
                                    <v-checkbox :error="hasError(acc.id)" :error-messages="errorMsgs(acc.id)" :disabled="!show_accessory(acc)" :hide-details="!hasError(acc.id)" slot="activator" v-on:click.passive="checkExclusiveOf(acc)" v-model="product.quote_accessories[acc.id]" :label="acc.label" name="accessories[]" :off-icon="'far fa-square'" :value="1">
                                        <v-tooltip v-if="acc.tooltip" top slot="append">
                                            <v-icon slot="activator" @click="showTip(acc.tooltip)" small>fa-question-circle</v-icon>
                                            <span>{{ acc.tooltip }} - ({{ acc.code }})</span>
                                        </v-tooltip>
                                    </v-checkbox>
                                </div>
                            </template>
                        </div>
                    </v-layout>
                </v-card>
                <div class="text-xs-right">
                    <v-btn @click="cancel()">Cancel</v-btn>
                    <v-btn @click="stepper = 3"><v-icon left>fas fa-arrow-alt-circle-left</v-icon>Back</v-btn>
                    <v-btn :disabled="(hasError() || incomplete)" color="primary" @click="nextStep()">Continue</v-btn>
                </div>
              </v-stepper-content>

              <v-stepper-content step="5" v-if="categories.length > 0">
                <v-card class="mb-5" height="500px">
                    <v-layout row wrap align-start class="pa-2">
                        <v-flex xs12>
                            <h3 class="mb-2">{{ categories[2].label }}</h3>
                        </v-flex>
                        <div class="accessory_columns">
                            <template v-for="(acc, k) in category_accessories(categories[2].id)">
                                <div :class="{ 'fade-more' : !show_accessory(acc) }" :key="'acc_' + k">
                                    <v-checkbox :error="hasError(acc.id)" :error-messages="errorMsgs(acc.id)" :disabled="!show_accessory(acc)" :hide-details="!hasError(acc.id)" slot="activator" v-on:click.passive="checkExclusiveOf(acc)" v-model="product.quote_accessories[acc.id]" :label="acc.label" name="accessories[]" :off-icon="'far fa-square'" :value="1">
                                        <v-tooltip v-if="acc.tooltip" top slot="append">
                                            <v-icon slot="activator" @click="showTip(acc.tooltip)" small>fa-question-circle</v-icon>
                                            <span>{{ acc.tooltip }} - ({{ acc.code }})</span>
                                        </v-tooltip>
                                    </v-checkbox>
                                </div>
                            </template>
                            <input v-for="(i, k) in selected_accessories" type="hidden" name="quote_accessories[]" :value="k" />
                        </div>
                    </v-layout>
                </v-card>
                <div class="text-xs-right">
                    <v-btn @click="cancel()">Cancel</v-btn>
                    <v-btn @click="stepper = 4"><v-icon left>fas fa-arrow-alt-circle-left</v-icon>Back</v-btn>
                    <v-btn :disabled="(hasError() || incomplete)" @click="$emit('submit')" color="primary" large>{{ !isNew ? 'Save Changes' : "Add Heater to Quote" }}<v-icon right>fas fa-plus-circle</v-icon></v-btn>
                </div>
              </v-stepper-content>

            </v-stepper-items>
          </v-stepper>

	</div>
</template>

<script>

    import QuoteItemForm from './QuoteItemForm.vue'
	import FieldRules from '../utils/FieldRules'
	const request = require('superagent');
	//import Options from '../tutco/options';

	export default {
        extends: QuoteItemForm,
		props : [],
        data : function(){

            return {
            	stepper : 0,
            }
        },
        mounted() {

        },
        methods : {
            nextStep(){
                if (this.incomplete){
                    return false;
                }else{
                    this.stepper++;
                }
            },
            validate_step_1(){
                if (this.product.product_id == null){
                    return false;
                }
                if (this.product.product == 'ROUNDF' && !(this.product.diameter > 0) ){
                    return false;
                }
                if (this.product.product != 'ROUNDF' && !(this.product.width > 0 && this.product.height > 0) ){
                    return false;
                }
                if (this.validate_recess() !== true){
                    return false;
                }
                return true
            },
            validate_step_2(){
                if (this.product.voltage == null){
                    return false;
                }
                if (!(this.product.kw > 0) ){
                    return false;
                }
                return true;
            }
        },
        computed : {
        	incomplete : function(){
                if (this.stepper >= 1){
                    if (!this.validate_step_1()){
                        return true;
                    }
                }
                if (this.stepper >= 2){
                    if (!this.validate_step_2()){
                        return true;
                    }
                }
                return false;
            }
        },
        watch : {

        }
	}

</script>

<style>
	.duct-image{
		max-height: 250px;
		max-width: 100%;
	}
</style>
